import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const superadminScopes = $("#superadmin-scopes");
    const merchantScopes = $("#merchant-scopes");
    const submerchantScopes = $("#submerchant-scopes");
    const merchantField = $(".profile_id_merchant");
    const submerchantField = $(".profile_id_submerchant");

    superadminScopes.hide();
    merchantScopes.hide();
    submerchantScopes.hide();
    merchantField.hide();
    submerchantField.hide();
  }

  hideFields() {
    const userType = $("#profile_user_type option:selected").text();
    const scopeFields = $("#scope-fields");

    const superadminScopes = $("#superadmin-scopes");
    const merchantScopes = $("#merchant-scopes");
    const submerchantScopes = $("#submerchant-scopes");
    const merchantField = $(".profile_id_merchant");
    const submerchantField = $(".profile_id_submerchant");

    superadminScopes.hide();
    merchantScopes.hide();
    submerchantScopes.hide();
    merchantField.hide();
    submerchantField.hide();

    if (userType == "Super Admin") {
      superadminScopes.show();
      superadminScopes.appendTo(scopeFields);
    } else if (userType == "Merchant") {
      merchantScopes.show();
      merchantScopes.appendTo(scopeFields);
      merchantField.show();
    } else if (userType == "Submerchant") {
      submerchantScopes.show();
      submerchantScopes.appendTo(scopeFields);
      submerchantField.show();
    }
  }
}
